module.exports = __webpack_public_path__ + "static/media/img-monochrome-logo-text.3305cc8c.pdf";